import vChatComposer from "./v-chat-composer.vue";

export default Vue => {
  Vue.component("v-chat-composer", vChatComposer);
};
